import type { BAAAcceptResponse, BAAStatusResponse, BAAVersion } from "../types/baa";
import type { APIInstance } from "./apiService";

const BAA_API_ROUTES = {
  status: (firmId: string) => `/firms/${firmId}/baa/status`,
  current: `/public/baa/current`,
  accept: (firmId: string) => `/firms/${firmId}/baa/accept`,
};

export class BAAService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async checkBAAStatus(firmId: string): Promise<BAAStatusResponse> {
    const response = await this.api.get<BAAStatusResponse>(BAA_API_ROUTES.status(firmId));
    return response.data;
  }

  async getCurrentBAA(): Promise<BAAVersion> {
    const response = await this.api.get<BAAVersion>(BAA_API_ROUTES.current);
    return response.data;
  }

  async acceptBAA(firmId: string, versionId: string): Promise<BAAAcceptResponse> {
    const response = await this.api.post<BAAAcceptResponse>(BAA_API_ROUTES.accept(firmId), {
      version_id: versionId,
    });
    return response.data;
  }
}
